module.exports = __webpack_public_path__ + "static/media/cloud1.79a02259.png";